import { Directive, ElementRef, Input, OnInit, OnChanges } from '@angular/core';
import { NgLocalStorage } from 'core/utils/ng-storage.service';
import { MsalService } from 'msal';
import { AuthenticationService } from 'core/authentication.service';

@Directive({
  selector: '[appDisabledWorkflowDashboardElements]'
})
export class DisabledWorkflowDashboardElementsDirective implements OnChanges {
  @Input() appDisabledWorkflowDashboardElements;
  @Input() disabled;
  @Input() entitygroup;
  @Input() entity;
  constructor(private eleRef: ElementRef, private ngLocalStorage: NgLocalStorage, private msalService: MsalService, private _auth: AuthenticationService) { }
  
  disableClass() {
    this.disabled = true;
    this.eleRef.nativeElement.style.pointerEvents = 'none';
    this.eleRef.nativeElement.style.cursor = 'not-allowed !important';
    this.eleRef.nativeElement.style.opacity = '0.65';
  }

  updatePermission(entity) {
    let response = JSON.parse(this.ngLocalStorage.getItem('workflowUserRoles'));
    let roles = this._auth.getUserRoles(this.msalService) ? this._auth.getUserRoles(this.msalService): [];
    let virtualEntityGroupList = [];
    if (this.appDisabledWorkflowDashboardElements != null)
      this.appDisabledWorkflowDashboardElements = this.appDisabledWorkflowDashboardElements.split(',');

    var recordEntityGroup = [];
    this.appDisabledWorkflowDashboardElements.forEach((value, key) => {
      var dataValues = value.split(':');
      var exists = false;
      exists = ((recordEntityGroup.filter((item) => { return item === dataValues[1] })).length > 0);
      if (exists == false && dataValues[1] != "" && dataValues[1] != null) { recordEntityGroup.push(dataValues[1]); }
    })
    let entityGroupList = recordEntityGroup ? recordEntityGroup: [];
    console.log('entityGroupList',entityGroupList);
    roles.forEach((value, key) => {
      let inValidRoleFlag = false;
      let userRolePermissions = response.filter((res) => { return res.RoleName === value });
      if (userRolePermissions.length != 0) {
        entityGroupList.forEach((val, key) => {
          if (val === undefined)
            val = "Pages";
          if (userRolePermissions[0] && userRolePermissions[0][val] && userRolePermissions[0][val][entity]) {
            var exists = false;
            exists = (virtualEntityGroupList.filter((item) => { return item === val }).length > 0);
            if (exists == false) { virtualEntityGroupList.push(val); }
          }
        })
      }
    });
    (entityGroupList.length != virtualEntityGroupList.length) ? this.disableClass() : this.enableClass();
  }

  ngOnChanges() {
    this.updatePermission(this.entity);
  }

  enableClass() {
    this.eleRef.nativeElement.style.pointerEvents = 'auto';
    this.eleRef.nativeElement.style.cursor = 'pointer';
  }

  ngOnInit() {
    
  }
}
